import { BookOpen, FolderOpen, Users, Award, PenLine, TrendingUp } from "lucide-react";

const Stat = ({ icon: Icon, label, value, sub, onClick, testId }) => (
  <button type="button" onClick={onClick} disabled={!onClick} className="group rounded-xl border border-border bg-white p-4 text-left transition-colors enabled:hover:border-green-300" data-testid={testId}>
    <Icon size={16} className="text-green-700" />
    <p className="mt-3 font-heading text-2xl font-bold text-slate-900">{value}</p>
    <p className="text-xs font-medium text-slate-700">{label}</p>
    {sub && <p className="text-[11px] text-slate-500">{sub}</p>}
  </button>
);

export const CourseOverviewTab = ({ course, onTab }) => (
  <div className="space-y-5" data-testid="course-overview-tab">
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
      <Stat icon={BookOpen} label="Lessons" value={course.lesson_count} sub={`${course.quiz_count} with a quiz`} onClick={() => onTab("lessons")} testId="overview-lessons" />
      <Stat icon={FolderOpen} label="Materials" value={course.material_count} sub="Files and links" onClick={() => onTab("materials")} testId="overview-materials" />
      <Stat icon={Users} label="Learners" value={course.learner_count} sub="Enrolled" onClick={() => onTab("learners")} testId="overview-learners" />
      <Stat icon={TrendingUp} label="Average progress" value={`${course.average_progress}%`} sub={`${course.completed_count} completed`} testId="overview-progress" />
      <Stat icon={PenLine} label="Awaiting marking" value={course.awaiting_marking} sub="Written answers" testId="overview-marking" />
      <Stat icon={Award} label="Certificates" value={course.certificates} sub="Issued" testId="overview-certificates" />
    </div>
    <div className="rounded-xl border border-border bg-white p-5">
      <h3 className="font-heading text-sm font-semibold">About this course</h3>
      <p className="mt-1 whitespace-pre-wrap text-sm text-slate-600" data-testid="overview-summary">{course.summary || "No summary yet — add one in Settings so learners know what to expect."}</p>
    </div>
    {(!course.is_published || course.lesson_count === 0) && (
      <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900" data-testid="overview-checklist">
        <p className="font-semibold">Before learners can start</p>
        <ul className="mt-1 list-disc pl-5 text-xs space-y-0.5">
          {course.lesson_count === 0 && <li>Add at least one lesson</li>}
          {!course.is_published && <li>Publish the course in Settings — drafts are hidden from learners</li>}
        </ul>
      </div>
    )}
  </div>
);
